/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { cached } from '@glimmer/tracking';
import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import { waitFor } from '@ember/test-waiters';
import UiBookingGuestCardComponent from 'uplisting-frontend/components/ui/booking/guest/card';
import { getBookingPanelBaseRouteFor } from 'uplisting-frontend/utils/rhs/routes';

export default class UiBookingV2GuestCardComponent extends UiBookingGuestCardComponent {
  @service notifications!: Services['notifications'];

  @cached
  get baseRoute(): string {
    return getBookingPanelBaseRouteFor(this.router.currentRouteName ?? '');
  }

  @action
  @waitFor
  async handleCopyUplistingId(): Promise<void> {
    await window.navigator.clipboard.writeText(this.booking.id);

    this.notifications.info(
      'action_bookings_messages.uplisting_booking_id_copied',
    );
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::BookingV2::Guest::Card': typeof UiBookingV2GuestCardComponent;
  }
}
